import _ from 'lodash';
import { createSelector } from 'reselect';
import Immutable from 'immutable';
import {
  getMaterialTypeCountsForStatus,
  getPresentStatusesFromSummary,
  getCountsByStatusFromSummary
} from '@bibliocommons/utils-borrowing';
import { getSummary } from './BorrowingSelector';
import { getShelvesForCurrentUser } from './ShelfSelector';

const checkedoutSummary = state => getSummary(state, 'checkedout');
const statusFilter = (state, props) => _.get(props, 'router.params.status');
const pagination = state => state.getIn(['borrowing', 'checkedout', 'pagination'], Immutable.Map());

const allCheckouts = state => state.getIn(['entities', 'checkouts'], Immutable.Map());
const bibsById = state => state.getIn(['entities', 'bibs'], Immutable.Map());
const checkoutTransactions = state => state.getIn(['borrowing', 'checkedout', 'checkoutTransactions'], Immutable.Map());
const checkedoutStatus = state => state.getIn(['borrowing', 'checkedout'], Immutable.Map());
const failuresByAction = state => state.getIn(['borrowing', 'checkedout', 'failures'], Immutable.Map());
const currentItemIds = state => state.getIn(['borrowing', 'checkedout', 'items'], Immutable.List());

export const getCheckoutsByMetadataId = createSelector(
  [allCheckouts],
  (checkoutsById) => checkoutsById.groupBy(checkout => checkout.get('metadataId'))
);

export const getCurrentCheckouts = createSelector(
  [currentItemIds, allCheckouts, bibsById, getShelvesForCurrentUser],
  (checkoutIds, checkoutsById, bibs, shelfItems) =>
    checkoutIds
      .map(id => checkoutsById.get(id))
      .filter(checkout => !!checkout)
      .map(checkout => checkout.set('bib', bibs.get(checkout.get('metadataId'))))
      .map((checkout) => {
        const isAlreadyOnShelf = shelfItems.some(
          (item) => (item.get('metadataId') === checkout.get('metadataId'))
        );

        const canAddToShelf = checkout.get('bib') && !isAlreadyOnShelf;

        const actions = canAddToShelf ?
          checkout.get('actions', Immutable.List()).push('addToShelf') :
          checkout.get('actions');

        return checkout.set('actions', actions);
      })
      .toList()
);

export const getCountsByStatus = createSelector(
  [checkedoutSummary],
  (summary) => getCountsByStatusFromSummary(summary)
);

export const getPagination = createSelector(
  [pagination],
  (page) => page
);

export const getMaterialTypeCounts = createSelector(
  [checkedoutSummary, statusFilter],
  (summary, currentStatus) => getMaterialTypeCountsForStatus(summary, currentStatus)
);

export const getPresentStatuses = createSelector(
  [checkedoutSummary],
  (summary) => getPresentStatusesFromSummary(summary)
);

export const getCheckedoutQuotas = createSelector(
  [checkedoutSummary],
  (summary) => summary.get('quotas', Immutable.List())
);

export const getSelectedStatus = createSelector(
  [statusFilter],
  (status) => status ? status.toUpperCase() : status
);

export const getCheckoutTransactions = createSelector(
  [checkoutTransactions],
  (transactions) => transactions
);

export const getCheckedoutStatus = createSelector(
  [checkedoutStatus],
  (status) => status
);

export const getFailuresByAction = createSelector(
  [failuresByAction],
  (failures) => failures
);

export const getRenewFailures = createSelector(
  [failuresByAction, bibsById, allCheckouts],
  (failures, bibs, checkouts) => failures
    .get('renew', Immutable.List())
    .map(failure => failure.set('checkout', checkouts.get(failure.get('id'))))
    .map(failure => failure.set('bib', bibs.get(failure.getIn(['checkout', 'metadataId']))))
);

export default {
  getMaterialTypeCounts,
  getPresentStatuses,
  getCheckedoutQuotas,
  getSelectedStatus,
  getCheckoutsByMetadataId,
  getPagination,
  getCheckoutTransactions,
  getCheckedoutStatus,
  getFailuresByAction,
  getRenewFailures,
  getCurrentCheckouts,
  getCountsByStatus
};



// WEBPACK FOOTER //
// ./app/selectors/CheckoutSelector.js